import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
    Box,
    IconChevronRight,
    Subtitle1,
    TextButton,
} from '@myphx-engineering/phx-design-system';
import { ConsumersIllustration, IllustrationCard } from '@phx/myphx-lib';

import { getAbsoluteRoute } from '../../util';

export const SaveMoneyFamilyCard = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <IllustrationCard
            Illustration={ConsumersIllustration}
            variant="filled"
            color="warning"
            header={<Subtitle1>{t('home.saveMoneyCard.heading')}</Subtitle1>}
            onClick={() => navigate(getAbsoluteRoute('startSaving'))}
            // oxlint-disable-next-line jsx-a11y/role-has-required-aria-props -- tracked in docs/oxlint-violations.md
            role="tab"
        >
            <Box>
                <TextButton RightIcon={IconChevronRight}>
                    {t('home.saveMoneyCard.button')}
                </TextButton>
            </Box>
        </IllustrationCard>
    );
};
